/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum MessageType {
    AI_MESSAGE = 'aiMessage',
    ASSISTANT_TOOL_CALLS = 'assistantToolCalls',
    CHARACTER_PHOTOS_UPLOADED = 'characterPhotosUploaded',
    ERROR_MESSAGE = 'errorMessage',
    NEW_CONVERSATION = 'newConversation',
    NOTIFICATION = 'notification',
    PERFORMER_CONTRACT_DECLINED = 'performerContractDeclined',
    SUPPORT_MESSAGE = 'supportMessage',
    CANCEL = 'cancel',
    SYSTEM_MESSAGE = 'systemMessage',
    TOOL_MESSAGE = 'toolMessage',
    TYPING = 'typing',
    UPDATED_CONVERSATION = 'updatedConversation',
    USER_MESSAGE = 'userMessage',
}
